/*!

=========================================================
* Argon Design System React - v1.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import ContactUsRequestPopup from "components/Popups/ContactUsRequestPopup";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
// reactstrap components
import {
  Button,
  Card,
  CardImg,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

const CardsFooter = () => {
  // Incremented each time the footer "Contact Us" link is clicked to open
  // the popup on demand. The timed/auto triggers were removed: the popup now
  // fires on exit intent or deep scroll, and never on these pages.
  const [contactFormSignal, setContactFormSignal] = useState(0);
  const { pathname } = useLocation();

  // Popping a lead form here is hostile: /contact-us visitors are already
  // contacting us, and /playground visitors are mid-customization.
  const popupDisabled = pathname === '/contact-us' || pathname === '/playground';

  const getPopupCopy = (path) => {
    if (path === '/pricing') {
      return {
        headline: 'Need a custom quote?',
        subline: "Tell us about your order volume and we'll tailor Enterprise pricing to your store."
      };
    }
    if (path.indexOf('/demo/') === 0) {
      return {
        headline: 'Questions about what you just saw?',
        subline: "Tell us about your store and we'll help you get this live — usually in under 10 minutes."
      };
    }
    return {
      headline: "Have questions? Let's talk.",
      subline: "Tell us about your store and we'll help with setup, Enterprise quotes, or anything else."
    };
  };
  const popupCopy = getPopupCopy(pathname);
    return (
      <>
        <footer className="footer has-cards">
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <Container>
            {/* <Row className="row-grid align-items-center my-md">
              <Col lg="6">
                <h3 className="text-primary font-weight-light mb-2">
                  Thank you for supporting us!
                </h3>
                <h4 className="mb-0 font-weight-light">
                  Let's get in touch on any of these platforms.
                </h4>
              </Col>
              <Col className="text-lg-center btn-wrapper" lg="6">
                <Button
                  className="btn-icon-only rounded-circle"
                  color="twitter"
                  href="#"
                  id="tooltip475038074"
                  target="_blank"
                >
                  <span className="btn-inner--icon">
                    <i className="fa fa-twitter" />
                  </span>
                </Button>
                <UncontrolledTooltip delay={0} target="tooltip475038074">
                  Follow us
                </UncontrolledTooltip>
                <Button
                  className="btn-icon-only rounded-circle ml-1"
                  color="facebook"
                  href="#"
                  id="tooltip837440414"
                  target="_blank"
                >
                  <span className="btn-inner--icon">
                    <i className="fa fa-facebook-square" />
                  </span>
                </Button>
                <UncontrolledTooltip delay={0} target="tooltip837440414">
                  Like us
                </UncontrolledTooltip>
                <Button
                  className="btn-icon-only rounded-circle ml-1"
                  color="dribbble"
                  href="#"
                  id="tooltip829810202"
                  target="_blank"
                >
                  <span className="btn-inner--icon">
                    <i className="fa fa-dribbble" />
                  </span>
                </Button>
                <UncontrolledTooltip delay={0} target="tooltip829810202">
                  Follow us
                </UncontrolledTooltip>
                <Button
                  className="btn-icon-only rounded-circle ml-1"
                  color="github"
                  href="#"
                  id="tooltip495507257"
                  target="_blank"
                >
                  <span className="btn-inner--icon">
                    <i className="fa fa-github" />
                  </span>
                </Button>
                <UncontrolledTooltip delay={0} target="tooltip495507257">
                  Star on Github
                </UncontrolledTooltip>
              </Col>
            </Row> */}
            <hr />
            <Row className="align-items-center justify-content-md-between">
              <Col md="3">
                <div className="copyright">
                  © {new Date().getFullYear()}{" "}
                  <a
                    href="#"
                    target="_blank"
                  >
                    Convert Logistics
                  </a>
                  .
                </div>
              </Col>
              <Col md="9">
                <Nav className="nav-footer justify-content-end">
                  <NavItem>
                    <NavLink
                      href="/privacy"
                    >
                      Privacy Policy
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="/about-us"
                    >
                      About Us
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="/attributions"
                    >
                      Attributions
                    </NavLink>
                  </NavItem>
                  <NavItem><NavLink style={{cursor: 'pointer'}} onClick={()=>{
                    // Manual open bypasses dismissal suppression, so don't
                    // clear the flag — otherwise auto-triggers would re-arm.
                    setContactFormSignal((n) => n + 1);
                  }}>Contact Us</NavLink></NavItem>
                  <NavItem><NavLink href="/articles">Articles</NavLink></NavItem>
                </Nav>
              </Col>
            </Row>
          </Container>
        </footer>
        <ContactUsRequestPopup
          disabled={popupDisabled}
          forceOpenSignal={contactFormSignal}
          headline={popupCopy.headline}
          subline={popupCopy.subline}
          source={pathname}
        />
      </>
    );
}

export default CardsFooter;
